import {createContext, useContext} from "react";
import type {Door} from "@/dungeons/model/DungeonGeometry.ts";
import type {DoorState} from "./DoorState.ts";

export type DoorStateContextValue = {
    initialLoading: boolean;
    stateFor: (door: Door) => DoorState;
    setDoorState: (door: Door, state: DoorState) => Promise<void>;
};

export const DoorStateContext = createContext<DoorStateContextValue | null>(null);

export function useDoorStates(): DoorStateContextValue {
    const context = useContext(DoorStateContext);
    if (!context) throw new Error("useDoorStates must be used within a DoorStateProvider");
    return context;
}
